var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search_bar"},[_c('button',{staticClass:"back_btn ab",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"btn_image"},[_c('img',{attrs:{"src":require('@/assets/images/calendar/prev.png'),"alt":""}})]),_vm._v("\n    前のページ\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77076e73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wallet/PageBack.vue
// module id = null
// module chunks = 